import React from 'react'

import { Home } from '@/pages'
import { Feedback } from '@/pages/feedback'

export const RoutesNames = {
  ROOT: '/',
  HOME: '/home',
  ERRO: '/erro',
}
export default [
  { path: RoutesNames.ROOT, element: <Home /> },
  { path: RoutesNames.ERRO, element: <Feedback /> },
]
